<div class="default-tab" [ngClass]="tabStyle">
  <ng-container [ngSwitch]="tabStyle">
    <!-- Default Tab -->
    <ng-container *ngSwitchCase="'default'">
      <div class="nav nav-tabs" role="tablist">
        <div class="nav-item" *ngFor="let tab of tabs; let i = index">
          <a class="nav-link"
             [class.active]="activeTab === i"
             [attr.data-bs-toggle]="'tab'"
             [attr.href]="'#tab-' + i"
             (click)="activateTab(i)"
             role="tab">
            <i class="{{ tab.icon }}"></i> {{ tab.title }}
          </a>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-pane fade show"
             [class.active]="activeTab === i"
             *ngFor="let tab of tabs; let i = index"
             [attr.id]="'tab-' + i">
          <div class="pt-4">
            <h4>{{ tab.title }}</h4>
            <p>{{ tab.content }}</p>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Custom Tab 1 -->
    <ng-container *ngSwitchCase="'custom-tab-1'">
      <ul class="nav nav-tabs">
        <li class="nav-item" *ngFor="let tab of tabs; let i = index">
          <a class="nav-link"
             [class.active]="activeTab === i"
             [attr.data-bs-toggle]="'tab'"
             [attr.href]="'#tab-' + i"
             (click)="activateTab(i)"
             role="tab">
            <i class="{{ tab.icon }}"></i> {{ tab.title }}
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane fade show"
             [class.active]="activeTab === i"
             *ngFor="let tab of tabs; let i = index"
             [attr.id]="'tab-' + i">
          <div class="pt-4">
            <h4>{{ tab.title }}</h4>
            <p>{{ tab.content }}</p>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Nav Pills Tabs -->
    <ng-container *ngSwitchCase="'nav-pills'">
      <ul class="nav nav-pills mb-4 light">
        <li class="nav-item" *ngFor="let tab of tabs; let i = index">
          <a class="nav-link"
             [class.active]="activeTab === i"
             [attr.data-bs-toggle]="'tab'"
             [attr.href]="'#tab-' + i"
             (click)="activateTab(i)">
            {{ tab.title }}
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <!-- Tab panes -->
      </div>
    </ng-container>

    <!-- Vertical Nav Pill -->
    <ng-container *ngSwitchCase="'vertical-nav-pill'">
      <div class="row">
        <div class="col-sm-4">
          <div class="nav flex-column nav-pills mb-3">
            <a href="#v-pills-{{ tab.title | lowercase }}"
               data-bs-toggle="pill"
               class="nav-link"
               [class.active]="activeTab === i"
               *ngFor="let tab of tabs; let i = index"
               (click)="activateTab(i)">
              {{ tab.title }}
            </a>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="tab-content">
            <!-- Tab panes -->
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Nav Pills Tabs 2 -->
    <ng-container *ngSwitchCase="'nav-pills-2'">
      <ul class="nav nav-pills justify-content-end mb-4">
        <li class="nav-item" *ngFor="let tab of tabs; let i = index">
          <a class="nav-link"
             [class.active]="activeTab === i"
             [attr.data-bs-toggle]="'tab'"
             [attr.href]="'#tab-' + i"
             role="tab"
             (click)="activateTab(i)">
            {{ tab.title }}
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <!-- Tab panes -->
      </div>
    </ng-container>

    <!-- Vertical Nav Pill 2 -->
    <ng-container *ngSwitchCase="'vertical-nav-pill-2'">
      <div class="row">
        <div class="col-sm-8">
          <div class="tab-content">
            <div id="v-pills-{{ tab.title | lowercase }}"
                 class="tab-pane fade"
                 [class.show]="activeTab === i"
                 *ngFor="let tab of tabs; let i = index">
              <p>{{ tab.content }}</p>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="nav flex-column nav-pills">
            <a href="#v-pills-{{ tab.title | lowercase }}"
               data-bs-toggle="pill"
               class="nav-link"
               [class.active]="activeTab === i"
               *ngFor="let tab of tabs; let i = index"
               (click)="activateTab(i)">
              {{ tab.title }}
            </a>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Tab with Icon -->
    <ng-container *ngSwitchCase="'tab-with-icon'">
      <div class="nav nav-tabs" role="tablist">
        <div class="nav-item" *ngFor="let tab of tabs; let i = index">
          <a class="nav-link"
             [class.active]="activeTab === i"
             [attr.data-bs-toggle]="'tab'"
             [attr.href]="'#tab-' + i"
             (click)="activateTab(i)"
             role="tab">
            <span><i class="{{ tab.icon }}"></i></span>
          </a>
        </div>
      </div>
      <div class="tab-content tabcontent-border">
        <div class="tab-pane fade show"
             [class.active]="activeTab === i"
             *ngFor="let tab of tabs; let i = index"
             [attr.id]="'tab-' + i"
             role="tabpanel">
          <div class="pt-4">
            <h4>This is {{ tab.title }} tab</h4>
            <p>{{ tab.content }}</p>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
